import _ from 'underscore';

// currency minimum value comes from:
// https://microsoft.sharepoint.com/:x:/t/MAPPMteamFTE/EchxuPoGaFROg-tM4pgNVngB45DJBXsBQQilJDSQEWh7fw?e=Fep9xL
const CURRENCY_FALLBACK_MINIMUM_BUDGET = {
  ArgentinePeso: 0.05,
  AustralianDollar: 0.05,
  BrazilianReal: 0.1,
  CanadianDollar: 0.05,
  ChileanPeso: 5.1,
  ColombianPeso: 18.05,
  DanishKrone: 0.06,
  Euro: 0.05,
  HongKongDollar: 1,
  IndianRupee: 0.82,
  IndonesianRupiah: 480,
  JapaneseYen: 5,
  MalaysianRingit: 0.15,
  MexicanPeso: 0.14,
  NewZealandDollar: 0.05,
  NigerianNaira: 0.05,
  NorwegianKrone: 0.06,
  PeruvianNuevoSol: 0.05,
  PhilippinePeso: 2,
  PolishZloty: 0.05,
  SaudiRiyal: 0.05,
  SingaporeDollar: 0.05,
  SouthAfricanRand: 0.05,
  SwedishKrona: 0.07,
  SwissFranc: 0.05,
  ThaiBaht: 2,
  TurkishLira: 0.05,
  UKPound: 0.05,
  UsDollar: 0.05,
};

// this is for fallback value,
// if the getUPBudgetSuggestion api return error, or the api doesn't support the locale.
// for currency that in CURRENCY_FALLBACK_MINIMUM_BUDGET,
// we use the value from CURRENCY_FALLBACK_MINIMUM_BUDGET as minimum budget value.
// if currency not in CURRENCY_FALLBACK_MINIMUM_BUDGET, we use the fixed value 0.001 as minimum budget value.
// all currency has the same maximum budget value 50000.
export const getFallbackEstimates = (currency) => {
  const minimumBudget = _.get(CURRENCY_FALLBACK_MINIMUM_BUDGET, currency);
  if (minimumBudget) {
    return {
      GlobalMinimumBudget: {
        DailyBudget: minimumBudget, MonthlyBudget: minimumBudget * 20,
      },
      MinimumBudget: {
        DailyBudget: minimumBudget, MonthlyBudget: minimumBudget * 20,
      },
      CompetitorBudgetLowerBound: null,
      SuggestedBudget: {
        DailyBudget: 10, MonthlyBudget: 200,
      },
      CompetitorBudgetUpperBound: null,
      MaximumBudget: {
        DailyBudget: 20000, MonthlyBudget: 400000,
      },
      GlobalMaximumBudget: {
        DailyBudget: 50000, MonthlyBudget: 1000000,
      },
      Currency: currency,
    };
  }

  return {
    GlobalMinimumBudget: {
      DailyBudget: 0.001, MonthlyBudget: 0.02,
    },
    MinimumBudget: {
      DailyBudget: 0.001, MonthlyBudget: 0.02,
    },
    CompetitorBudgetLowerBound: null,
    SuggestedBudget: {
      DailyBudget: 10, MonthlyBudget: 200,
    },
    CompetitorBudgetUpperBound: null,
    MaximumBudget: {
      DailyBudget: 20000, MonthlyBudget: 400000,
    },
    GlobalMaximumBudget: {
      DailyBudget: 50000, MonthlyBudget: 1000000,
    },
    Currency: currency || 'UsDollar',
  };
};

